import React, { useState } from 'react'
import { DropdownItem, DropdownMenu, DropdownToggle } from '@byscott-io/corebyscott'
import { DropdownWrapper } from './Dropdown'

const DropdownSelect = props => {
  const [opened, setOpened] = useState(false)
  const [selected, setSelected] = useState(props.selected)

  const toggle = () => setOpened(!opened)

  const select = (option) => {
    setSelected(option)
    props.callbacck && props.callback(option)
  }

  return <DropdownWrapper className="cbs-scope inline-block" isOpen={opened} toggle={toggle}>
    <DropdownToggle nav caret>
      {selected?.name}
    </DropdownToggle>
    <DropdownMenu>
      {(props.options || []).filter(op => op && op.name).map((op, i) => <DropdownItem key={i} onClick={() => select(op)}>{op.name}</DropdownItem>)}
    </DropdownMenu>
  </DropdownWrapper>
}

export default DropdownSelect
